// extracted by mini-css-extract-plugin
export default {"signal":"SignalPerks_signal"};